<template>
    <section class="PerformancePreviewFileDialog">
        <el-dialog
            v-dialogDrag
            v-if="dialogVisible"
            :title="title"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-press-escape="flag"
            :width="width"
            :before-close="hide"
            :custom-class="'PerformancePreviewFileDialog'"
        >
            <div class="updateUserInfo">
                <span>{{ updateUserName }}</span
                >在<span>{{ updateTime }}</span
                >上传
            </div>
            <div class="fileName-text">
                {{ name }}
            </div>
            <div class="img-content" style="height: 500px">
                <ul id="viewers" style="display: none" v-if="dialogVisible">
                    <li v-for="(item, index) in srcList" :key="index">
                        <img :src="item" />
                    </li>
                </ul>
            </div>
        </el-dialog>
    </section>
</template>
<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
export default {
    name: 'PerformanceCommonDialog',
    props: {
        title: {
            type: String,
            default: '附件预览'
        },
        width: {
            type: String,
            default: '750px'
        },
        attachmentList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            dialogVisible: false,
            updateUserName: '',
            carouselIndex: '',
            updateTime: '',
            name: '',
            viewer: {},
            flag: true,
            srcList: []
        };
    },
    methods: {
        /**
         * @description 切换图片时，更新图片上传信息
         * @param 当前显示图片索引
         */
        updateInfo (index) {
            this.updateUserName = this.attachmentList[index].updateUserName;
            this.updateTime = this.attachmentList[index].updateTime;
            this.name = this.attachmentList[index].name;
            this.carouselIndex = index;
        },
        // 初始化viewer插件
        initViewer () {
            if (this.srcList.length > 0) {
                const barOptions = { show: true, size: 'default' };
                this.viewer = new Viewer(document.getElementById('viewers'), {
                    inline: true,
                    navbar: true,
                    backdrop: true, // 透明背景色
                    zoomOnWheel: true, // 滚动缩放
                    toolbar: {
                        zoomIn: barOptions,
                        zoomOut: barOptions,
                        oneToOne: barOptions,
                        reset: barOptions,
                        prev: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === 0) {
                                    return this.$message.warning('当前图片是第一张');
                                } else {
                                    this.carouselIndex -= 1;
                                    this.viewer.prev(true);
                                }
                            }
                        },
                        play: barOptions,
                        next: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === this.attachmentList.length - 1) {
                                    return this.$message.warning('当前图片是最后一张');
                                } else {
                                    this.carouselIndex += 1;
                                    this.viewer.next(true);
                                }
                            }
                        },
                        rotateLeft: barOptions,
                        rotateRight: barOptions,
                        flipHorizontal: barOptions,
                        flipVertical: barOptions

                    },
                    viewed: data => { // 图片加载完成时回调
                        this.updateInfo(data.detail.index);
                    }
                });
            }
        },
        // 关闭弹窗
        hide () {
            this.dialogVisible = false;
        },
        /**
         * @description: 判断键盘事件 实现逐级退出功能
         * @return {*}
         */
        keyDown () {
            document.onkeydown = e => {
                if (e.code === 'Escape') {
                    this.flag = !(e.target.className === 'viewer-button viewer-fullscreen viewer-fullscreen-exit');
                }
            };
        },
        // 显示弹窗
        show () {
            this.srcList = this.attachmentList.map(v => v.path);
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.keyDown();
                this.initViewer();
            });
        }
    },
    beforeDestroy () {
        this.viewer.destroy();
    }
};
</script>
<style lang="less">
.PerformancePreviewFileDialog {
    .el-dialog__body {
        text-align: center;

        .fileName-text {
            margin-top: 10px;
            margin-bottom: 15px;
            text-align: center;
            overflow: hidden; /* 隐藏溢出内容 */
            white-space: nowrap; /* 强制内容在一行显示 */
            text-overflow: ellipsis; /* 添加省略号 */
        }

        .updateUserInfo {
            line-height: 30px;
            font-size: 14px;

            > span {
                margin: 0 5px;
            }
        }

        .viewer-title {
            color: #000;
        }
    }
}
</style>
